<app-gallery [id]="fOffer.id" [images]="fOffer.images"></app-gallery>
<h3><a [id]="type+':result'" [routerLink]="['/journeys', fOffer.id]">{{ fOffer.title }}</a></h3>
<app-offer-stat stat="days" [value]="fOffer.days"></app-offer-stat>
<app-offer-stat stat="price" [value]="fOffer.price"></app-offer-stat>
<app-offer-stat stat="rating" [value]="fOffer.rating"></app-offer-stat>
